/**
 * Enum defining the types of navigation items
 * Used to distinguish between different levels and purposes in the navigation hierarchy
 */
export let BrowseNavItemType = /*#__PURE__*/function (BrowseNavItemType) {
  BrowseNavItemType["SECTION"] = "section";
  BrowseNavItemType["ITEM"] = "item";
  BrowseNavItemType["CATEGORY"] = "category";
  BrowseNavItemType["SUBCATEGORY"] = "subcategory";
  BrowseNavItemType["TOPIC"] = "topic";
  return BrowseNavItemType;
}({});

/**
 * Context object passed to render functions
 * Provides i18n utilities and other data needed for rendering
 */

/** Children of a navigation node - items or sections */

/**
 * Base interface for all navigation items
 * Contains common properties shared across all navigation types
 */

/**
 * Standard navigation item (category, subcategory, topic, etc.)
 * Represents a clickable navigation element with title and URL
 */

/**
 * Navigation section - groups related items together
 * Can have a title and optional decoration (e.g., "NEW" badge)
 */
//# sourceMappingURL=navigation.js.map